<template>
    <div class="kt-portlet pl-md-3">
        <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
                <h6 class="kt-portlet__head-title">
                    Detalle vehículo personalizado
                </h6>
            </div>
        </div>
        <div class="container-fluid p-0 m-0">
            <imagen :cargando="false" :activo360="false" :activar="false" ></imagen>
        </div>
        <div class="container-fluid p-0 m-0">
            <div class="m-5">
                <div>
                    <h5 class="text-capitalize" v-if="pasosAn1">{{minusculas(pasosAn1.modelo.dt1)}} {{anio}}</h5>
                    <h6 class="text-capitalize text-muted" v-if="pasosAn2.color.dt1">{{minusculas(pasosAn2.color.dt1)}}</h6>
                </div>
                <table class="col">
                    <tbody>
                    <tr v-for="item in pasosAn3.resumen" :key="item.id">
                        <td>
                            <h6>{{item.dt1}}</h6>
                        </td>
                        <td class="pl-5 text-right">
                            <h6 class="precio-syb">{{puntos(item.ndt1)}}</h6>
                        </td>
                    </tr>
                    <tr class="sum-total" v-if="pasosAn3">
                        <td class="pl-5 text-right" colspan="2" >
                            <h6 class="precio-syb font-weight-bold">{{puntos(suma(pasosAn3.resumen))}}</h6>
                        </td>
                    </tr>
                    <tr v-for="item in pasosAn2.accesorios.individuales" :key="item.id">
                        <td>
                            <h6>{{item.dt2}}</h6>
                        </td>
                        <td class="pl-5 text-right">
                            <h6 class="precio-syb">{{puntos(item.ndt2)}}</h6>
                        </td>
                    </tr>
                    <tr v-for="item in pasosAn2.accesorios.kit" :key="item.id">
                        <td>
                            <h6>{{item.dt2}}</h6>
                        </td>
                        <td class="pl-5 text-right">
                            <h6 class="precio-syb">{{puntos(item.ndt2)}}</h6>
                        </td>
                    </tr>
                    <tr v-for="item in pasosAn2.accesorios.cupones" :key="item.id">
                      <td>
                        <h6>{{item.dt1}}</h6>
                      </td>
                      <td class="pl-5 text-right">
                        <h6 class="precio-syb">{{puntos(item.ndt3)}}</h6>
                      </td>
                    </tr>
                    <tr class="sum-total" v-if="pasosAn2.accesorios.kit.length>0 || pasosAn2.accesorios.individuales.length>0 || pasosAn2.accesorios.cupones.length>0">
                        <td class="pl-5 text-right" colspan="2">
                            <h6 class="precio-syb font-weight-bold">{{puntos(suma2(pasosAn2.accesorios.individuales,pasosAn2.accesorios.kit)+suma3('ndt3',pasosAn2.accesorios.cupones))}}</h6>
                        </td>
                    </tr>
                    <tr class="sum-total-f">
                        <td>
                            <b>Precio total</b>
                        </td>
                        <td class="pl-5 text-right">
                            <h6 class="precio-syb font-weight-bold">{{puntos(suma2(pasosAn2.accesorios.individuales,pasosAn2.accesorios.kit)+suma(pasosAn3.resumen)+suma3('ndt3',pasosAn2.accesorios.cupones))}}</h6>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import constantes from "../../constantes";
    import imagen from "../Paso2/Imagen/imagen-vehiculo";
    export default {
        name: "resumen-vertical",
        components:{
            imagen,
        },
        computed:{
            pasosAn1:function(){
                return this.$store.getters.getPasos[1] !== undefined ? this.$store.getters.getPasos[1] : false;
            },
            pasosAn2:function(){
                return this.$store.getters.getPasos[2] !== undefined ? this.$store.getters.getPasos[2] : false;
            },
            pasosAn3:function(){
                return this.$store.getters.getPasos[3] !== undefined ? this.$store.getters.getPasos[3] : false;
            },
            anio:function(){
                return this.$store.getters.getPasos[2].version.ndt10 || null
            },
        },
        methods:{
            minusculas:(dato)=>constantes.funciones.minusculas(dato),
            puntos:(numero)=>constantes.funciones.puntoMilesDecimal(numero),
            suma:(vector)=>constantes.funciones.sumar(vector),
            suma2:(vector1,vector2)=>constantes.funciones.sumar2(vector1,vector2),
            suma3:(key,vector)=>constantes.funciones.sumar3(key,vector),
        }
    }
</script>

<style scoped>
    .precio-syb::before {
        vertical-align: super;
        font-size: 0.55em;
        content: '$';
    }
    .sin-pad {
        padding: 0px;
    }
</style>
